<template>
  <v-menu
    ref="menu"
    :offset-y="true"
    transition="slide-y-transition"
    bottom
    :close-on-content-click="false"
    nudge-bottom="5"
    class="selected-filters"
  >
    <template v-slot:activator="{ on, attrs, value }">
      <v-btn
        color="white"
        class="filter-btn mr-5 mb-5"
        v-bind="attrs"
        v-on="on"
      >
        <span>{{ label }}</span>
        <font-awesome-icon :icon="value ? 'chevron-up' : 'chevron-down'" />
      </v-btn>
    </template>
    <slot />
  </v-menu>
</template>

<script>
  export default {
    name: 'FilterMenu',
    props: {
      label: String,
    },
  }
</script>
